import { render, staticRenderFns } from "./CoreSuperiority.vue?vue&type=template&id=ca6ed158&scoped=true&"
import script from "./CoreSuperiority.vue?vue&type=script&lang=js&"
export * from "./CoreSuperiority.vue?vue&type=script&lang=js&"
import style0 from "./CoreSuperiority.vue?vue&type=style&index=0&id=ca6ed158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6ed158",
  null
  
)

export default component.exports